import React from 'react';
import clsx from 'clsx';

const Spinner = ({ className }) => <div className={clsx("spinner", className)} />;

export default Spinner;
